// extracted by mini-css-extract-plugin
export default {"menuBlock":"HG-z","title":"IG-z","nav":"JG-z","flexCell":"KG-z","facetLink":"LG-z"};